import { gql } from "@apollo/client";

const FEDERATIONS = gql`
  query federations(
    $filter: ListFederationInput
    $orderBy: Boolean
    $arrayOfPlatform: [Int!]
    $limit: Int
    $page: Int
    $search: String
  ) {
    federations(
      filter: $filter
      orderBy: $orderBy
      arrayOfPlatform: $arrayOfPlatform
      limit: $limit
      page: $page
      search: $search
    ) {
      federations {
        user {
          name
          surname
          email
          phone
          id
          surname
          role
        }
        organizationName
        organizationAbbreviation
        status
        clubs {
          id
          clubName
        }
        leagues {
          id
          league {
            id
            title
          }
        }
        platforms {
          platform {
            id
            title
          }
        }
        logo
        about
        contactEmail
        contactPhone
        website
        id
        createdAt
      }
      total
    }
  }
`;

export default FEDERATIONS;
